import { useState } from "react";

import { UNSUITABLE_REASON_KEYS } from "@/components/shared/business/UnsuitableReason/constants/unsuitableReason.constants";
import { ProcessStatusCode } from "@/types/code.types";
import {
  usePublishableArticleInfoMutation,
  useReviewRequiredMutation,
} from "@api/articleInfo/useArticleInfo";
import { useCreateEntryDataMutation } from "@api/createEntryData/createEntryData";
import { useUnsuitablePressCancelMutation } from "@api/unsuitablePress/unsuitablePress";
import { DRAFT_STATUS_CODE } from "@constants/draftStatusCode.constants";

import PublishableCheckboxIcon from "./components/PublishableCheckboxIcon/PublishableCheckboxIcon";

type Props = {
  data: {
    pressId: number;
    reviewIdList: number[] | null;
    publishable: boolean;
    draftArticleStatus: ProcessStatusCode;
    aiDone: boolean;
  };
};

export const PressListPublishableContainer = ({ data }: Props) => {
  const { mutateAsync: updatePublishable } =
    usePublishableArticleInfoMutation();
  const { mutateAsync: createEntryData } = useCreateEntryDataMutation();

  const { mutateAsync: turnOffUnsuitable } = useUnsuitablePressCancelMutation(
    UNSUITABLE_REASON_KEYS.pressList,
  );
  const { mutateAsync: updateReviewRequiredStatus } = useReviewRequiredMutation(
    UNSUITABLE_REASON_KEYS.pressList,
  );

  const [, setTargetUnsuitablePressId] = useState<number>(0);

  const createDAE = (id: number) => {
    createEntryData(id);
  };

  const handlePublishable = (
    id: number,
    publishable: boolean,
    status: ProcessStatusCode,
    aiDone: boolean,
  ) => {
    if (status === DRAFT_STATUS_CODE.unsuitable) {
      turnOffUnsuitable(id);
      updateReviewRequiredStatus({
        pressId: id,
        requiredReviewInfo: {
          isReviewRequired: false,
          reviewId: data.reviewIdList || [],
          newInfoDetails: null,
        },
      });
      updatePublishable({
        draftArticleId: id,
        isPublishable: publishable,
      });

      setTargetUnsuitablePressId(0);

      if (publishable === true && aiDone === false) {
        createDAE(id);
      }
      return;
    }
    updatePublishable({
      draftArticleId: id,
      isPublishable: publishable,
    });
    setTargetUnsuitablePressId(0);
    if (publishable === true && status === DRAFT_STATUS_CODE.notForAiEntry) {
      createDAE(id);
    }
  };

  return (
    <PublishableCheckboxIcon
      isChecked={data.publishable || false}
      onClick={() =>
        handlePublishable(
          data.pressId,
          !data.publishable,
          data.draftArticleStatus,
          data.aiDone || false,
        )
      }
    />
  );
};
